module.exports = "https://web-assets.ifttt.com/packs/media/pro_trial/img-hello-card-web-responsive-min-c97d4004.jpg";